module.exports = __webpack_public_path__ + "img/sender-company-name.93cf3503.svg";